import React, { Component } from "react";
import style from "./AddSubCategory.module.css";
import { connect } from "react-redux";
import { fetchDropdownList } from "../../redux";
import api from "../../utils/Api";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import history from "../../utils/history";

export class AddSubCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPageTitle: "Add Sub Category",
      isEdit: false,
      sub_category_id: "",
      subCatDropdownList: [],
      filteredSubCatOptionsData: [],
      choose_category: "",
      exist_subcat_list: "",
      add_sub_category: "",
      lower_threshold: "",
      upper_threshold: "",
      categoryVal: "",
      subCatDetails: [],
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      error: "",
      isScreenLoaded: false
    };
  }

  componentDidMount() {
    document.title = 'Edit Subcategory - TechToMedix';
    // Ftech dropdwon options for sub category
    this.getDropdown();

    // Fetching route parameters
    if (this.props.match.params.id) {
      this.setState(
        {
          isEdit: true,
          isPageTitle: "Update Sub Category",
          subCatDetails: this.props.location.state,
        },
        () => {
          // fetch specific product details
          this.fetchSubCatDetails();
        }
      );
    }
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
  }, 2000);
  }

  // Calling fetch specific sub categories details
  fetchSubCatDetails = () => {
    this.setState({
      sub_category_id: this.state.subCatDetails.sub_category_id,
      choose_category: this.state.subCatDetails.category_id,
      add_sub_category: this.state.subCatDetails.sub_category_name,
      lower_threshold: this.state.subCatDetails.lower_threshold,
      upper_threshold: this.state.subCatDetails.upper_threshold,
    });
  };

  getDropdown = async () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get("inventory/dropdown/fetch/", {
        headers: headers,
      });

      if (response.status == 200) {
        this.setState({
          subCatDropdownList: response.data.data,
        });
      }
    } catch (error) {
      console.log(
        "Error for fetching sub dropdown fro add product page",
        error
      );
    }
  };

  // Handle input change
  handleInputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });

    if (name === "choose_category") {
      this.state.filteredSubCatOptionsData = this.state.subCatDropdownList.filter(
        (element, index) => {
          return element.category_id == val;
        }
      );
    }
  };

  // handleBlur
  handleBlurChange = () => {
    if (
      this.state.choose_category !== "" &&
      this.state.add_sub_category !== "" &&
      this.state.lower_threshold !== "" &&
      this.state.upper_threshold !== ""
    ) {
      this.setState({
        error: "",
      });
    }
  };

  gotoBack = () => {
    history.push("/subcategorieslist");
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      this.setState({
        isEdit: false,
        sub_category_id: "",
        choose_category: "",
        exist_subcat_list: "",
        add_sub_category: "",
        lower_threshold: "",
        upper_threshold: "",
        isPageTitle: "Add Sub Category",
      });
    }
  }

  // Submitting block time data
  onSubmit = async () => {
    // Input form validations
    if (
      this.state.choose_category === "" ||
      this.state.add_sub_category === "" ||
      this.state.lower_threshold === "" ||
      this.state.upper_threshold === ""
    ) {
      this.setState({
        error: "Please filled out all mandatory fields",
      });
    } else {
      this.setState({
        isLoading: true,
      });
      const payload = {
        category_id: Number(this.state.choose_category),
        sub_category_name: this.state.add_sub_category,
        lower_threshold: Number(this.state.lower_threshold),
        upper_threshold: Number(this.state.upper_threshold),
      };

      if (this.state.isEdit) {
        payload.sub_category_id = this.state.sub_category_id;
      }

      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };

      try {
        const response = await api.post("inventory/subcategory/save", payload, {
          headers: headers,
        });
        if (response.status === 200) {
          this.setState({
            isLoading: false,
            successMessage: "Sub Category added sucessfully!",
          });
          if (this.state.isEdit) {
            this.setState({
              isLoading: false,
              successMessage: "Sub Category updated successfully!",
            });
          }
          setTimeout(() => {
            this.setState({
              successMessage: "",
            });
            history.push("/subcategorieslist");
          }, 2000);
        }
      } catch (error) {
        console.log("Error in add sub category save ", error);
        this.setState({
          isLoading: false,
          errorMessage: "Error in save sub category",
        });
        setTimeout(() => {
          this.setState({
            errorMessage: "",
          });
        }, 2000);
      }
    }
  };

  render() {
    const dropdownData = this.props.dropdownListData.dropdownList;

    // Getting category dropdwon data
    const categoryOptionsData =
      dropdownData.category &&
      dropdownData.category.map((element, index) => (
        <option value={element.category_id}>{element.category_name}</option>
      ));

    if (this.state.isEdit) {
      this.state.filteredSubCatOptionsData = this.state.subCatDropdownList.filter(
        (element, index) => {
          return element.category_id === this.state.choose_category;
        }
      );
    }

    const subCatOptionsData =
      this.state.subCatDropdownList &&
      this.state.filteredSubCatOptionsData.map((element, index) => (
        <option value={element.sub_category_id}>
          {element.sub_category_name}
        </option>
      ));

      if(!this.state.isScreenLoaded){
        return(
        <div className="dashboard-loader">
              <img src={ttmLoader} alt="loader" className="loader-image" />
          </div>
          );
    }

    return (
      <div className={style.addSubCategoryMainWrapper}>
        <div className="row">
          <div className="col-lg-12">
            <h3>{this.state.isPageTitle}</h3>
          </div>
          <div className="col-lg-12 intro-text">
            <p className="mb-4">
              Here new sub category can be added. The new sub category will be
              created under a selected main categoryHere new sub category can be
              added. The new sub category will be created under a selected main
              category
            </p>
          </div>
        </div>
        <div class="form-box-shadow">
          <div className="row">
            <div className="col-lg-12">
              <h6>Sub Category Details</h6>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="form-group">
                <div className="form-group">
                  <label htmlFor="choose_category_id">
                    Choose Category :{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <select
                    className="form-control"
                    id="choose_category_id"
                    name="choose_category"
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlurChange}
                    value={this.state.choose_category}
                  >
                    <option value="">Select Category</option>
                    {categoryOptionsData}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="form-group">
                <div className="form-group">
                  <label htmlFor="exist_subcat_list_id">
                    Existing Sub Categories (For Reference) :
                  </label>
                  <select
                    className="form-control"
                    id="exist_subcat_list_id"
                    name="exist_subcat_list"
                    value={this.state.exist_subcat_list}
                    disabled={!this.state.choose_category}
                  >
                    {subCatOptionsData}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-xl-4">
              <div className="form-group">
                <div className="form-group">
                  <label htmlFor="add_sub_category_id">
                    Sub Category Name :{" "}
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="add_sub_category_id"
                    name="add_sub_category"
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlurChange}
                    value={this.state.add_sub_category}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="form-group">
                <label htmlFor="lower_threshold_id">
                  Lower Threshold :{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="lower_threshold_id"
                  name="lower_threshold"
                  value={this.state.lower_threshold}
                  onChange={this.handleInputChange}
                  onBlur={this.handleBlurChange}
                />
              </div>
            </div>
            <div className="col-md-6 col-xl-4">
              <div className="form-group">
                <label htmlFor="upper_threshold_id">
                  Upper Threshold :{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="upper_threshold_id"
                  name="upper_threshold"
                  value={this.state.upper_threshold}
                  onChange={this.handleInputChange}
                  onBlur={this.handleBlurChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.error && (
              <div className={`error ${style.errorText}`}>
                {this.state.error}
              </div>
            )}
          </div>
        </div>
        <div
          className={`d-flex justify-content-center justify-content-sm-end ${style.subCatbtnWrapper}`}
        >
          {/* <button
            type="button"
            class="tmed-btn tmed-primary-btn"
            onClick={this.gotoBack}
          >
            Cancel
          </button> */}
          <button
            type="button"
            class="tmed-btn tmed-primary-btn"
            onClick={this.onSubmit}
          >
            Save
          </button>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.isLoading ? (
              <div className={style.loadingWrapper}>
                <img src={ttmLoader} className={style.loading} />
              </div>
            ) : (
              <div>
                {this.state.successMessage && (
                  <p className={style.successMessage}>
                    {this.state.successMessage}
                  </p>
                )}
                {this.state.errorMessage && (
                  <p className={style.errorMessage}>
                    {this.state.errorMessage}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddSubCategory);
